/**
 * Generated by orval v6.20.0 🍺
 * Do not edit manually.
 * portrich-api
 * OpenAPI spec version: 0.0.0
 */

/**
 * * `OCEAN` - 船舶
* `AIR` - 航空
 */
export type FreightMethodEnum = typeof FreightMethodEnum[keyof typeof FreightMethodEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FreightMethodEnum = {
  OCEAN: 'OCEAN',
  AIR: 'AIR',
} as const;
